<template>
  <button
    :id="`nav-button-${ flashcardStatus.id }`"
    class="navigation-button"
    :class="{
      green: isGreen,
      bookmarked: isYellow,
      selected: isSelected,
      red: isRed,
    }"
    tabindex="0"
    data-test="navigation-button"
    @click="navigate"
    @keydown.enter.prevent="navigate"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    flashcardStatus: {
      type: Object,
      default: () => ({}),
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isSimulationComplete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['navigate'],
  computed: {
    /**
     * If the simulation is complete, the button should be green if the flashcard is answered correctly.
     * If the simulation is not complete, the button should be green if the flashcard is answered.
     */
    isGreen() {
      if (this.isSimulationComplete && this.flashcardStatus.isAnswered) {
        return this.flashcardStatus.isCorrect;
      }
      return this.flashcardStatus.isAnswered;
    },
    /**
     * If the simulation is complete, the button should be red if the flashcard is answered incorrectly.
     * If the simulation is not complete, the button should not be red.
     */
    isRed() {
      return this.isSimulationComplete && !this.flashcardStatus.isCorrect;
    },
    /**
     * If the simulation is complete, the button not be yellow
     * If the simulation is not complete, the button should be yellow if the flashcard is bookmarked
     */
    isYellow() {
      return !this.isSimulationComplete && this.flashcardStatus.isBookmarked;
    },
  },
  watch: {
    isSelected(newValue) {
      this.$nextTick(() => {
        if (newValue) {
          document.getElementById(`nav-button-${ this.flashcardStatus.id }`).scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      });
    },
  },
  methods: {
    navigate() {
      this.$emit('navigate', this.flashcardStatus.id, 'sidebar');
    },
  },
};
</script>

<style lang='scss' scoped>
.navigation-button {
  height: 32px;
  width: 32px;
  border-radius: 16px;
  background-color: #C4C4C4;
  border: 1px solid #7B7B7B;
  font-size: 13px;
  color: #555555;
  font-weight: 600;
  padding-left: 0;
  padding-right: 0;

  &.bookmarked,
  &.green.bookmarked {
    color: #262626;
    background-color: #FFD83E;
  }

  &.green {
    color: white;
    background-color: #00B46D;
  }

  &.selected {
    border: 1px solid #262626;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    font-weight: 700;
  }

  &.red {
    color: white;
    background-color: #DC3416;
  }

  &.selected:not(.green):not(.bookmarked) {
      color: black;
  }
}

</style>
